import { client } from './client';
// Login via Telegram code (see contracts.ts for the flow). The session token is
// attached to every request by the axios interceptor in client.ts.
export function sendLoginCode(username) {
    const body = { username };
    return client.post('/auth/send-code', body);
}
export function verifyLoginCode(username, code) {
    const body = { username, code };
    return client.post('/auth/verify-code', body);
}
// Always hits the backend so admin status + permissions are the server's truth.
export function fetchMe() {
    return client.get('/auth/me');
}
export function logout() {
    return client.post('/auth/logout');
}
